import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { useContext } from 'react';
import { ThemeContext } from '../context/themeContext';

const SidebarButton = () => {
  const { darkMode, toggleTheme } = useContext(ThemeContext);

  return (
    <div className="fixed bottom-10 right-10 sm:right-5 md:right-10 flex justify-center items-center z-50">
      <button
        onClick={toggleTheme}
        className="bg-white dark:bg-gray-800 p-3 rounded-full shadow-lg text-gray-600 dark:text-gray-400 focus:outline-none hover:bg-gray-100 dark:hover:bg-gray-700 transition"
      >
        <FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="w-6 h-6" />
      </button>
    </div>
  );
};

export default SidebarButton;
